import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import Box from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import { TextSpan } from "../../Styled/Text";

// only spans are valid html for buttons (even though divs work)
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ButtonWrapper = styled(Box).attrs({
  as: "span"
}).withConfig({
  displayName: "MapIconButton__ButtonWrapper",
  componentId: "sc-12ve1j3-0"
})(["display:flex;justify-content:center;align-items:center;transition:flex 0.3s ease-out;"]);
// styles half ripped from nav.scss
const StyledMapIconButton = styled(RawButton).withConfig({
  displayName: "MapIconButton__StyledMapIconButton",
  componentId: "sc-12ve1j3-1"
})(["border-radius:16px;", " ", " background:", ";color:", ";border:1px solid ", ";height:32px;min-width:32px;direction:rtl;box-shadow:0 2px 4px 0 rgba(0,0,0,0.15);svg{height:20px;width:20px;margin:0 auto;vertical-align:middle;fill:", ";}", " ", " ", " ", ""], props => props.roundLeft && "border-radius: 16px 0 0 16px;", props => props.roundRight && "border-radius: 0 16px 16px 0;", props => props.theme.dark, props => props.theme.textLight, props => props.theme.darkLighter, props => props.theme.grey, props => props.primary && "\n    background: ".concat(props.theme.colorPrimary, ";\n    border: 1px solid ").concat(props.theme.colorPrimary, ";\n    color: ").concat(props.theme.textLight, ";\n    svg {\n      fill: ").concat(props.theme.textLight, ";\n      stroke: ").concat(props.theme.textLight, ";\n    }\n  "), props => props.splitter && !props.disabled && "\n    background: ".concat(props.theme.colorSecondary, ";\n    color: ").concat(props.theme.textLight, ";\n    svg {\n      fill: ").concat(props.theme.textLight, ";\n    }\n  "), props => props.inverted && "\n    background: ".concat(props.theme.charcoalGrey, ";\n    color: ").concat(props.theme.textLight, ";\n    svg {\n      fill: ").concat(props.theme.textLight, ";\n    }\n  "), props => props.disabled && "\n    background-color: ".concat(props.theme.grey, ";\n    color: ").concat(props.theme.grey, ";\n    opacity: 0.7;\n    svg {\n      fill: ").concat(props.theme.textLightDimmed, ";\n    }\n  "));
var _StyledStyledMapIconButton = styled(StyledMapIconButton).withConfig({
  displayName: "MapIconButton___StyledStyledMapIconButton",
  componentId: "sc-12ve1j3-2"
})(["svg{margin:0px 6px;}"]);
function MapIconButton(props) {
  const [isExpanded, setExpanded] = useState(false);
  const {
    children,
    roundLeft,
    roundRight,
    title,
    expandInPlace,
    neverCollapse,
    primary,
    splitter,
    inverted,
    disabled,
    noExpand = false
  } = props;
  const expanded = !noExpand && (isExpanded || neverCollapse) && children;
  const buttonRef = useRef();
  const theme = useTheme();

  // const handleAway = () => setTimeout(() => setExpanded(false), 1000);
  const handleAway = () => setExpanded(false);
  const handleFocus = expanded => {
    if (!disabled) {
      setExpanded(expanded);
    }
  };
  const MapIconButtonRaw = /*#__PURE__*/_jsx(_StyledStyledMapIconButton, {
    ref: props.buttonRef || buttonRef,
    className: props.className,
    primary: primary,
    splitter: splitter,
    inverted: inverted,
    roundLeft: roundLeft,
    roundRight: roundRight,
    disabled: disabled,
    type: "button",
    title: title,
    onMouseOver: () => handleFocus(true),
    onFocus: () => handleFocus(true),
    onMouseOut: handleAway,
    onBlur: handleAway,
    onClick: props.onClick,
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [primary && props.closeIconElement && /*#__PURE__*/_jsx(_StyledSpan, {
        children: props.closeIconElement()
      }), children && /*#__PURE__*/_jsx(_StyledTextSpan, {
        noWrap: true,
        medium: true,
        $_css: expanded ? "visible" : "hidden",
        $_css2: expanded ? "150px" : "0px",
        $_css3: expanded ? "10px" : "0px",
        $_css4: expanded ? "1.0" : "0",
        children: children
      }), props.iconElement && /*#__PURE__*/_jsx(_StyledSpan2, {
        children: props.iconElement()
      })]
    })
  });
  // we need to add some positional wrapping elements if we need to expand the
  // button in place (`absolute`ly) instead of in the layout flow (`relative`).
  if (expandInPlace) {
    return /*#__PURE__*/_jsx(_StyledDiv, {
      $_css5: expandInPlace && "\n            position:relative;\n            width: 32px;\n            height: 32px;\n            margin:auto;\n            @media (max-width: ".concat(theme.mobile, "px) {\n              width: ").concat(primary && !!props.closeIconElement && !isExpanded ? "64px" : "32px", ";\n            }\n          "),
      children: /*#__PURE__*/_jsx(_StyledDiv2, {
        $_css6: expandInPlace && "\n              position:absolute;\n              top:0;\n              right:0;\n              ".concat(isExpanded && "z-index:10;", "\n            "),
        children: MapIconButtonRaw
      })
    });
  } else return MapIconButtonRaw;
}

// const MapIconButtonWithRef = (props, ref) => (
//   <MapIconButton {...props} buttonRef={ref} />
// );

// export default React.forwardRef(MapIconButtonWithRef);

export default MapIconButton;
var _StyledSpan = styled("span").withConfig({
  displayName: "MapIconButton___StyledSpan",
  componentId: "sc-12ve1j3-3"
})(["display:block;"]);
var _StyledTextSpan = styled(TextSpan).withConfig({
  displayName: "MapIconButton___StyledTextSpan",
  componentId: "sc-12ve1j3-4"
})(["display:block;transition:visibility 0.3s ease,max-width 0.3s ease,margin-right 0.3s ease,opacity 0.3s ease;visibility:", ";max-width:", ";margin-right:", ";opacity:", ";"], p => p.$_css, p => p.$_css2, p => p.$_css3, p => p.$_css4);
var _StyledSpan2 = styled("span").withConfig({
  displayName: "MapIconButton___StyledSpan2",
  componentId: "sc-12ve1j3-5"
})(["display:block;"]);
var _StyledDiv = styled("div").withConfig({
  displayName: "MapIconButton___StyledDiv",
  componentId: "sc-12ve1j3-6"
})(["", ""], p => p.$_css5);
var _StyledDiv2 = styled("div").withConfig({
  displayName: "MapIconButton___StyledDiv2",
  componentId: "sc-12ve1j3-7"
})(["", ""], p => p.$_css6);